







































import Vue from 'vue'

interface CProps {
  animationStatus: boolean
}
interface CData {
  shareDialogOpen: boolean
}
interface CMethods {
  toggleShare(): void
  openLink(event: Event): void
}
interface CComputed {
  facebookLink: string
  twitterLink: string
  parentContent: any
}

export default Vue.extend<CData, CMethods, CComputed, CProps>({
  name: 'Sharer',
  props: {
    animationStatus: Boolean
  },
  data() {
    return {
      shareDialogOpen: false
    }
  },
  methods: {
    toggleShare() {
      if (this.shareDialogOpen) {
        setTimeout(() => (this.shareDialogOpen = !this.shareDialogOpen), 400)
      } else this.shareDialogOpen = !this.shareDialogOpen
    },
    openLink(event) {
      event.preventDefault()
      window.open((event.target as HTMLLinkElement).href)
      this.toggleShare()
    }
  },
  computed: {
    facebookLink() {
      return `https://www.facebook.com/sharer/sharer.php?u=${this.parentContent.permalink}`
    },
    twitterLink() {
      return `https://twitter.com/share?url=${this.parentContent.permalink}`
    },
    parentContent() {
      return this.$store.getters.parentContent
    }
  }
})
